import React from "react";
import Context from "../../Context";
import Blocker from "../Misc/Blocker";
import TablerowAdjButtons from "../Misc/TablerowAdjButtons";
import Select from "react-select";

const types = {
  string: "Строка",
  integer: "Целое число",
  double: "Число",
  timestamp: "Дата и время",
  boolean: "Да / Нет",
  document: "Ссылка на документ",
  reference: "Справочник",
  subform: "Другая форма",
};

export default class EssenceReferenceFormEdit extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      editData: {},
      pending: false,
      fields: [],

      references: [],

      subforms: [],
    };
  }

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.init();
    }
  }

  init = async () => {
    this.setState({ pending: true });
    const editData = this.props.data;
    let fields = [];

    if (this.props.id && this.props.id !== "add") {
      fields = await this.context.api.qa("/form/field/list", {
        filter: { form: this.props.id },
        orderby: ["sequence ASC"],
      });
    }

    let subforms = await this.context.api.qr("/form/list");
    let referencesQuery = await this.context.api.qac("/class");
    let references = referencesQuery.map((r) => {
      return {
        value: r.code,
        label: r.label,
      };
    });

    this.setState(
      {
        editData,
        pending: false,
        fields,
        subforms,
        references,
      },
      () => {
        this.triggerChange();
        if (this.props.onInit) {
          this.props.onInit({
            onAfterSave: this.onAfterSave,
          });
        }
      }
    );
  };

  getReferenceValue = (value, reference) => {
    if (Array.isArray(reference)) {
      return reference.find((item) => item.value === value) || null;
    }
    return {};
  };

  onAfterSave = async (data = {}) => {
    if (data.id) {
      this.setState({ pending: true });
      const { fields } = this.state;
      let saveFields = [];
      let sequence = 0;
      fields.forEach((field, idx) => {
        if (field.key) {
          saveFields.push({
            key: field.key,
            type: field.type || "string",
            label: field.label,
            mutable: false,
            sequence: ++sequence,
            value: field.value,
          });
        }
      });
      let result = await this.context.api.q("/form/field", {
        form: data.id,
        fields: saveFields,
      });
      if (!result) {
        this.context.toast("Не удалось сохранить поля формы", "error");
      }
      this.setState({ pending: false });
    }
  };

  onChange = (key, value) => {
    this.setState(
      (state) => {
        let editData = state.editData;
        editData[key] = value;
        return { editData };
      },
      () => this.triggerChange()
    );
  };

  onFieldChange = (idx, key, value) => {
    let { fields } = this.state;
    fields[idx][key] = value;
    this.setState({ fields });
  };

  triggerChange = () => {
    if (this.props.onChange) {
      this.props.onChange({});
    }
  };

  rowAdd = (idx) => {
    let { fields } = this.state;
    let index = idx || 0;
    fields.splice(index, 0, {});
    this.setState({ fields });
  };

  rowRemove = (idx) => {
    let { fields } = this.state;
    fields.splice(idx, 1);
    this.setState({ fields });
  };

  rowUp = (idx) => {
    if (idx > 0) {
      let { fields } = this.state;
      fields.splice(idx - 1, 2, fields[idx], fields[idx - 1]);
      this.setState({ fields });
    }
  };

  rowDown = (idx) => {
    let { fields } = this.state;
    fields.splice(idx, 2, fields[idx + 1] || {}, fields[idx]);
    this.setState({ fields });
  };

  render() {
    const { fields, references, subforms } = this.state;

    return (
      <>
        <Blocker on={this.state.pending}>
          <hr />
          <h5>Поля формы:</h5>
          <table className="table">
            <thead>
              <tr>
                <th>Код</th>
                <th>Тип</th>
                <th>
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1">Заголовок</div>
                    <div className="ml-3 text-nowrap">
                      <i
                        title="Добавить строку ниже"
                        onClick={() => this.rowAdd(0)}
                        className="fa fa-plus cursor-pointer text-hover-primary ml-2"
                      ></i>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {fields.map((item, idx) => {
                let field = item || {};
                return (
                  <tr key={idx}>
                    <td>
                      <input
                        className="form-control"
                        value={field.key || ""}
                        placeholder="Код"
                        onChange={(e) =>
                          this.onFieldChange(idx, "key", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <select
                        onChange={(e) =>
                          this.onFieldChange(idx, "type", e.target.value)
                        }
                        value={field.type || "string"}
                        className="form-control"
                      >
                        {Object.entries(types).map(([typeKey, typeLabel]) => (
                          <option key={typeKey} value={typeKey}>
                            {typeLabel}
                          </option>
                        ))}
                      </select>

                      {field.type === "reference" && (
                        <Select
                          isClearable
                          value={this.getReferenceValue(
                            field.value,
                            references
                          )}
                          onChange={(result) =>
                            this.onFieldChange(idx, "value", result?.value)
                          }
                          className="from-control react-select mt-2"
                          classNamePrefix="react-select-inner"
                          options={references}
                          placeholder="Выберите справочник..."
                          noOptionsMessage={({ inputValue }) =>
                            `Ничего не найдено по запросу ${inputValue}`
                          }
                        />
                      )}

                      {field.type === "subform" && (
                        <Select
                          isClearable
                          value={this.getReferenceValue(field.value, subforms)}
                          onChange={(result) =>
                            this.onFieldChange(idx, "value", result?.value)
                          }
                          className="from-control react-select mt-2"
                          classNamePrefix="react-select-inner"
                          options={subforms}
                          placeholder="Выберите форму..."
                          noOptionsMessage={({ inputValue }) =>
                            `Ничего не найдено по запросу ${inputValue}`
                          }
                        />
                      )}
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <input
                            className="form-control"
                            value={field.label || ""}
                            placeholder="Заголовок"
                            onChange={(e) =>
                              this.onFieldChange(idx, "label", e.target.value)
                            }
                          />
                        </div>

                        <div className="ml-3">
                          <TablerowAdjButtons
                            idx={idx}
                            rowAdd={this.rowAdd}
                            rowUp={this.rowUp}
                            rowRemove={this.rowRemove}
                            rowDown={this.rowDown}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Blocker>
      </>
    );
  }
}
